import { render, staticRenderFns } from "./TemplateDialogForm.vue?vue&type=template&id=9048f894&"
import script from "./TemplateDialogForm.vue?vue&type=script&lang=js&"
export * from "./TemplateDialogForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports